module.exports = __webpack_public_path__ + "static/media/coursera.a3d5608e.png";